export default {
  cover: '/images/about/cover-about.jpg',
  who: '/images/about/who.jpg',
  why: '/images/about/why.jpg',
  quote: {
    author: {
      it: 'John Elkann, presidente della Fondazione Agnelli',
      en: 'John Elkann, Chairman of Fondazione Agnelli'
    },
    text: {
      it: `Con le risorse del PNRR messe in campo dall’Europa, l’Italia ha un’occasione unica per migliorare la qualità dell’istruzione: l’obiettivo è dare a tutti gli studenti opportunità di benessere e di partecipazione alla vita civile, aiutando così il Paese a crescere, innovare, competere. Un'occasione che va colta, con l'impegno di tutti gli attori.`,
      en: `The NRRP resources provided by Europe offer Italy a unique opportunity to improve the quality of its education: the goal is to give all students ways to access wellbeing and participation in civic life, thus helping the country to grow, innovate and raise its competitive edge. It is an opportunity we cannot afford to miss, requiring joint efforts from all the players involved.`,
    },
    authorImg: '/images/quotes/ELKAN_Quote.png'
  }
};
